export var name = "@atlaskit/editor-core";
export var version = "206.1.3";